import { ProductCard as ProductCardHOC } from './ProductCard'
import { ProductCradHOCProps } from '../interfaces/interfaces'

import { ProductTitle } from './ProductTitle'
import { ProductImage } from './ProductImage'
import { ProductButtons } from './ProductButtons'

export { ProductButtons } from './ProductButtons'
export { ProductImage } from './ProductImage'
export { ProductTitle } from './ProductTitle'

export const ProductCard: ProductCradHOCProps = Object.assign(ProductCardHOC, {
    Title: ProductTitle,
    Img: ProductImage,
    Buttons: ProductButtons,
})

export default ProductCard
